import React from 'react'
import  { useState, useEffect } from 'react'
import axios from 'axios'

const Government = () => {

 

  return (
    <div>
     <div className="Gov">
  <p>
• Community Outreach Programs -GBVF (Gender-Based Violence & Femicide) prevention and awareness<br></br>
• Victim Support & Trauma Counselling<br></br>
• Youth Empowerment & Skills Development<br></br>
• Family Strengthening Programs -parenting workshops, conflict resolution, positive discipline<br></br>
• Policy Implementation Support -assisting with social development initiatives<br></br>
• Crisis Response Services -for community-wide trauma and disaster relief<br></br>
  </p>
  </div>
     
     

    </div>
  );
}

export default Government